module.exports = __webpack_public_path__ + "static/img/image1.7c06bda8.png";